import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const OnboardingHybridLoginDirective = angularDirectiveToReact('onboardingHybridLogin', {});

export function OnboardingHybridLoginComponent() {
    const [key] = useAngularToReactRoute();
    return <OnboardingHybridLoginDirective key={key} />;
}
